import { appShell } from "./shell"
import CustomerZone from "@/client/components/customer_zone"

export default appShell(CustomerZone)
